<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <template v-slot:title>Supplier Comp</template>
    <v-row>
      <v-col>
        <v-text-field
          type="number"
          label="Pax From"
          v-model.number="paxFrom"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          label="Pax To"
          v-model.number="paxTo"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          label="Free"
          v-model.number="free"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          label="Pass"
          v-model.number="pass"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col sm="4">
        <v-select
          label="Service"
          :items="inUseServices"
          item-text="node.name"
          item-value="node.id"
          v-model="selectedService"
          :outlined="outlinedInputs"
        ></v-select>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onAdd">{{
        saveBtnLabel
      }}</v-btn>
    </template>
    <code v-if="debug">{{ selectedService }}-{{ services }}</code>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import ServiceTypeListSelect from "../../shared/ServiceTypeListSelect";
export default {
  name: "supplier-comp-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
    services: {
      type: Array,
      default: () => [],
    },
  },

  components: { BasicDialog, ServiceTypeListSelect },

  data() {
    return {
      debug: false,
      selectedService: this.value ? this.value.serviceId : "",
      paxFrom: this.value ? this.value.paxFrom : 1,
      paxTo: this.value ? this.value.paxTo : 1,
      free: this.value ? this.value.free : 0,
      pass: this.value ? this.value.pass : 0,
      serviceType:
        this.value && this.value.serviceType ? this.value.serviceType : "",
    };
  },

  computed: {
    inUseServices() {
      return this.services.filter((s) => !s.node.notInUse);
    },
    saveBtnLabel() {
      return this.value && this.value.id ? "Save" : "Add";
    },
    isValid() {
      return this.selectedService != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.paxFrom = newVal.paxFrom;
      this.paxTo = newVal.paxTo;
      this.free = newVal.free;
      this.pass = newVal.pass;
      this.serviceType = newVal.serviceType;
      this.selectedService = newVal.serviceId;
    },
  },

  methods: {
    onAdd() {
      this.$emit("save", {
        id: this.value && this.value.id ? this.value.id : undefined,
        paxFrom: Number(this.paxFrom),
        paxTo: Number(this.paxTo),
        free: Number(this.free),
        pass: Number(this.pass),
        //serviceType: this.serviceType,
        serviceId: this.selectedService,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/comps/SupplierCompDialog.vue